import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import appConfig from '../config/config';

const dynamicLoadPath = appConfig.ROUTER_BASE_PATH + '/locales/{{lng}}/{{ns}}.json'; // Es: /ui-toolbox/locales/... o /locales/...

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it', // Lingua predefinita
    preload: ['it', 'en'],
    supportedLngs: ['it', 'en'], // Lingue supportate
    defaultNS: 'common',
    ns: ['common', 'error', 'cropselector', 'farmselector', 'footer', 'map', 'modelselector', 
         'operationcreator', 'parcelform', 'roiselector', 'soiltexture', 'tabparcel', 'tabupload',
         'weatherdataselection', 'registerpage', 'topnavbar', 'unauthorizedpage', 'usersetting', 'app'], // Elenco dei namespace precaricati
    fallbackNS: 'common',
    load: 'currentOnly',
    debug: true, // Abilita i log in sviluppo
    backend: {
      loadPath: dynamicLoadPath,
      allowMultiLoading: true,
      retry: (count, err, namespace) => {
        if (count > 3) return false;
        return true;
      },
    },
    overloadTranslationOptionHandler: (args) => {
      const defaultValue = args[1];
      return {
        defaultValue,
        ns: args[1] && args[1].includes('translation:') ? 'common' : args[3]
      };
    },
    partialBundledLanguages: true,
    initImmediate: false,
    saveMissing: true,
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation - lng: ${lng}, ns: ${ns}, key: ${key}`);
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      caches: ['cookie', 'localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;